export default "__VITE_ASSET__4fC2Fk7K__"